<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '~/types/types'

const props = defineProps<{ block: SiteBlock }>()

const addJob = () => {
  props.block.data.jobs = [
    ...(props.block.data.jobs ?? []),
    { title: '', location: '', employment_type: '', description: '', apply_url: '' }
  ]
}
const removeJob = (i: number) => {
  props.block.data.jobs?.splice(i, 1)
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <SiteEditorArrayItemCard
    v-for="(job, i) in block.data.jobs ?? []"
    :key="i"
    :label="`Job ${i + 1}`"
    @remove="removeJob(i)"
  >
    <UInput
      v-model="job.title"
      placeholder="Job title"
      class="w-full"
    />
    <div class="grid grid-cols-2 gap-2">
      <UInput
        :model-value="job.location ?? ''"
        placeholder="Location"
        @update:model-value="job.location = String($event)"
      />
      <UInput
        :model-value="job.employment_type ?? ''"
        placeholder="Full-time…"
        @update:model-value="job.employment_type = String($event)"
      />
    </div>
    <UTextarea
      :model-value="job.description ?? ''"
      :rows="3"
      placeholder="Description"
      class="w-full"
      @update:model-value="job.description = String($event)"
    />
    <UInput
      :model-value="job.apply_url ?? ''"
      placeholder="Apply URL"
      class="w-full"
      @update:model-value="job.apply_url = String($event)"
    />
  </SiteEditorArrayItemCard>
  <UButton
    size="sm"
    variant="outline"
    color="neutral"
    icon="i-lucide-plus"
    @click="addJob"
  >
    Add job
  </UButton>
</template>
